<template>
  <v-container fluid>
    <v-layout justify-center>
      <v-flex xs12 sm12>
        <DataTableMain :datatable="table" :on-success="successAction" :itemsAction="tableAction"/>
      </v-flex>
    </v-layout>
    <MainFormDialog v-if="get_dialogMain.dialog" :fields="form" :model="object" :urls="url" :message="message" />
  </v-container>
</template>

<script>
import { mapGetters, mapActions, mapMutations } from 'vuex'
import DataTableMain from '@/components/tables/DataTableMain'
import MainFormDialog from '@/components/dialogs/MainFormDialog'
import { Permission } from '@/mixins/permissionMain'
export default {
  mixins: [Permission],
  data: () => ({
    table: {
      header: {
        options: [
          { title: 'Refrescar', icon: 'mdi-cached', color: 'primary', action: 'refreshData', code: 'libre', hidden: '' },
          { title: 'Nuevo', icon: 'mdi-plus', color: 'success', action: 'newData', code: 'nomina-cuentas-empleados.new' }
        ],
        titles: [
          { text: 'Cve Empleado', value: 'cve_empleado', class: 'black--text' },
          { text: 'Nombre Empleado', value: 'empleado.NombreCompleto', class: 'black--text' },
          { text: 'NumeroCuenta', value: 'NumeroCuenta', class: 'black--text' },
          { text: 'Clave Banco', value: 'banco.clave', class: 'black--text' },
          { text: 'Nombre Banco', value: 'banco.nombre', class: 'black--text' },
          { text: 'Activo', value: 'Activo', class: 'black--text' },
          { text: '', value: 'ActionsLocal', class: 'black--text' }
        ],
        loading: false
      },
      body: {
        data: [],
        actions: [
          { title: 'Editar Cuenta', icon: 'mdi-pencil', color: 'yellow darken-3', action: 'updateData', code: 'nomina-cuentas-empleados.new' }
        ]
      },
      footer: {
        paging: true
      }
    },
    object: {},
    form: {},
    url: {},
    message: ''

  }),
  components: {
    DataTableMain,
    MainFormDialog
  },
  mounted () {
    this.getUrl('POST/nomina/cuentas/show')
    this.ShowPermisos({ permisos: JSON.parse(localStorage.getItem('permisos')), tableMain: this.table })
  },
  methods: {
    successAction (item) {
      this[item.action](item)
    },
    refreshData (item) {
      this.table.header.loading = true
      this.getUrl('POST/nomina/cuentas/show')
    },
    newData (item) {
      this.form = this.get_cuentasEmpleadosForm
      this.object = {}
      this.url = this.get_urls['POST/nomina/cuentas/new']
      this.message = 'Registro Agregado Correctamente'
      this.SHOW_DIALOG_MAIN({ type: 'create', with: 850, title: 'Nueva Cuenta' })
    },
    tableAction (item) {
      this[item.action](item)
    },

    updateData (item) {
      this.form = this.get_cuentasEmpleadosForm
      this.object = item.item
      this.url = this.get_urls['POST/nomina/cuentas/new']
      this.message = 'Registro Agregado Correctamente'
      this.SHOW_DIALOG_MAIN({ type: 'create', with: 850, title: 'Nueva Cuenta' })
    },

    ...mapActions(['getUrlServices', 'postServiceListAction']),
    getUrl (objet) {
      if (this.get_urls != null) {
        const router = this.get_urls[objet]
        this.postServiceListAction({ url: router, data: {} })
      } else {
        this.getUrlServices()
      }
    },
    ...mapMutations(['SHOW_DIALOG_MAIN', 'CLEAR_DATA_LIST'])

  },
  computed: {
    ...mapGetters(['get_dialogMain', 'get_urls', 'get_objects', 'get_cuentasEmpleadosForm'])
  },
  watch: {
    get_urls (val) {
      this.getUrl('POST/nomina/cuentas/show')
    },
    get_objects (vals) {
      if (vals) {
        this.table.header.loading = false
        this.table.body.data = vals
      }
    }
  },
  beforeDestroy () {
    this.CLEAR_DATA_LIST()
  }
}
</script>

<style>

</style>
